import TYPES from './types';
import parseTime from '../util/parse-time';

const convertors: Record<string, (str: string) => unknown> = {
    [TYPES.bool]: (str: string): boolean => str === 'true' || str === '1',
    [TYPES.int]: (str: string): number => parseInt(str, 10),
    [TYPES.float]: parseFloat,
    [TYPES.time]: parseTime,
};

export default convertors;
